const Engine = [
  { code: "google", name: "Google" },
  { code: "bhashini", name: "Bhashini" },
];

export { Engine };